<template>
  <BasePopover
    v-model="open"
    class="m-title"
    :popper-id="popperId"
    :placement="placement"
    :options="resultPopperOptions"
    :reference-selector="referenceSelector"
    :reference-element="referenceElement"
    :activate-delay="activateDelay"
    show-on="hover"
    :offset="offset"
  >
    <template slot="reference">
      <slot />
    </template>
    <template slot="popper">
      <div
        class="m-title__content-wrapper"
        :class="hintClass"
      >
        <slot name="content" />
        {{ title }}
      </div>
    </template>
  </BasePopover>
</template>

<script>
  import BasePopover from 'components/common/BasePopover';

  const defaultPopperOptions = {
    modifiers: {
      preventOverflow: {
        enabled: false,
        boundariesElement: 'viewport'
      },
      hide: {
        enabled: false
      }
    }
  };

  export default {
    name: 'MTitle',
    components: {BasePopover},
    inheritAttrs: false,
    props: {
      placement: {
        type: BasePopover.props.placement.type,
        required: BasePopover.props.placement.required,
        default: 'bottom-start'
      },
      popperId: {
        type: String,
        default: ''
      },
      popperOptions: {
        type: Object,
        default: Object
      },
      referenceElement: {
        type: HTMLElement,
        default: null
      },
      referenceSelector: {
        type: String,
        default: null
      },
      hintClass: {
        type: [String, Array, Object],
        default: ''
      },
      title: {
        type: String,
        default: ''
      },
      offset: {
        type: String,
        default: '0,0'
      },
      activateDelay: {
        type: Number,
        default: 500
      }
    },
    data () {
      return {
        open: false
      };
    },
    computed: {
      resultPopperOptions () {
        return {...defaultPopperOptions, ...this.popperOptions};
      }
    }
  };
</script>

<style>
  .m-title .popper {
    box-shadow: 0 0 10px rgba(134, 134, 134, 0.25);
  }

  .m-title .popper__wrapper {
    display: inline;
  }

  .m-title__content-wrapper {
    font-size: 12px;

    color: var(--secondary-text-color);

    display: flex;

    flex-direction: column;
    justify-content: center;

    box-sizing: border-box;
    width: max-content;
    max-width: 269px;
    min-width: 0;

    padding: 4px 8px;
  }

  .m-title__content-wrapper .m-title__row:not(:first-child) {
    margin-top: 4px;
  }
</style>
